import { globalIgnoredMessages } from '@/lib/ThirdPartyScripts/globalIgnoredMessages'

export enum ErrorType {
  REACT_HYDRATION = 'react_hydration',
  CHUNK_FAILURE = 'chunk_failure',
  DOM_ERROR = 'dom_error',
  REQUEST_ABORTED = 'request_aborted',
  TIMEOUT = 'timeout',
  UNKNOWN = 'unknown',
}

export interface ErrorClassification {
  type: ErrorType
  tags: Record<string, string>
}

export function classifyError(error: Error | string): ErrorClassification {
  const message = typeof error === 'string' ? error : error.message || ''

  if (message.includes('Minified React error')) {
    return {
      type: ErrorType.REACT_HYDRATION,
      tags: { severity: 'high', category: 'react' },
    }
  }

  if (/loading chunk .* failed/i.test(message)) {
    return {
      type: ErrorType.CHUNK_FAILURE,
      tags: { severity: 'low', category: 'deployment' },
    }
  }

  if (
    message === 'The object can not be found here.' ||
    /failed to execute.*on 'Node'/i.test(message)
  ) {
    return {
      type: ErrorType.DOM_ERROR,
      tags: {
        severity: 'low',
        category: 'dom',
        cause: 'likely_google_translate',
      },
    }
  }

  if (message === 'Request aborted') {
    return {
      type: ErrorType.REQUEST_ABORTED,
      tags: { severity: 'medium', category: 'network' },
    }
  }

  if (message === 'timeout exceeded') {
    return {
      type: ErrorType.TIMEOUT,
      tags: { severity: 'medium', category: 'network' },
    }
  }

  return {
    type: ErrorType.UNKNOWN,
    tags: { severity: 'medium', category: 'unknown' },
  }
}

export function shouldReportError(message: string, stack: string | undefined): boolean {
  if (stack?.includes('/airgap.js')) return false

  return globalIgnoredMessages.every((pattern) => {
    if (typeof pattern === 'string') {
      return pattern !== message
    }
    return !pattern.test(message)
  })
}
